<template>
  <v-card
    class="story-card card-wrapper d-flex flex-column justify-space-between"
    tile
    flat
  >
    <v-card-title class="card-title">{{ content.title }}</v-card-title>
    <div>
      <v-card-text>
        <youtube
          player-width="100%"
          player-height="150px"
          :video-id="content.youtubeRef"
        ></youtube>
      </v-card-text>

      <v-expand-transition>
        <v-card
          tile
          flat
          v-if="show"
          v-click-outside="onClickOutside"
          class="transition-fast-in-fast-out v-card--reveal more-info"
        >
          <v-card-text class="pb-0">
            <div v-html="content.description"></div>
          </v-card-text>
        </v-card>
      </v-expand-transition>

      <v-card-actions
        class="d-flex justify-space-between"
        @click="show = !show"
      >
        <v-btn color="green" text>Info</v-btn>
        <v-btn icon>
          <v-icon color="green">
            {{ show ? 'mdi-minus' : 'mdi-plus' }}
          </v-icon>
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'StoryCard',
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    onClickOutside() {
      this.active = false
    },
  },
}
</script>

<style lang="scss">
.story-card {
  border: 1px solid #878a8c !important;
  height: 360px;

  .card-title {
    font-family: $heading-font-family;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-transform: uppercase;
    overflow-wrap: normal;
    word-break: normal;
  }

  .more-info {
    position: absolute;
    bottom: 0;
    background-color: rgba(#e4e3e1, 0.98);
    height: 358px;
    a {
      text-decoration: none !important;
      color: #995d81 !important;
    }
  }
}
</style>
